import React from 'react';
import { Box, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useFormField } from './FormFieldContext';

export const FormFieldError: React.FC<{ marginTop?: number }> = ({
  marginTop = 0,
}) => {
  const { isError, errorMessage, isReadOnly } = useFormField();

  if (!isError || !errorMessage || isReadOnly) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginTop,
      }}
    >
      <ErrorIcon color="error" sx={{ mr: 1, fontSize: 20 }} />
      <Typography color="error" variant="caption">
        {errorMessage}
      </Typography>
    </Box>
  );
};
